import { CustomInput as _CustomInput, CustomInputProps as _CustomInputProps } from "reactstrap";

    export const CustomInput = _CustomInput;
    export type CustomInputProps = _CustomInputProps;
    